import * as React from "react";
function SvgCamera(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <rect
        x={1}
        y={7}
        width={30}
        height={22}
        rx={1}
        ry={1}
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      />
      <path
        fill="none"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
        d="M3 3h8"
      />
      <circle
        cx={16}
        cy={18}
        r={6}
        fill="none"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgCamera);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
